// extracted by mini-css-extract-plugin
module.exports = {"result":"_5D3z6mWV","result__small":"_5D2m6DLQ","btn":"_5D1o2nmu","token-info":"_5D3LBB48","token-info__token":"_5D17brym","token-info__copy":"_5D6IZOuv"};